import script from "./SelectWithMultiLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectWithMultiLabel.vue?vue&type=script&setup=true&lang=js"

import "./SelectWithMultiLabel.vue?vue&type=style&index=0&id=f266fc7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f266fc7a"]])

export default __exports__